"use client"

import { useEffect, useState } from "react"
import WalletPage from "./layouts/wallet-page"
import WalletCard from "./layouts/wallet-card"
import WithdrawalSummary from "./layouts/withdrawal-summary"
import { Download, Upload, BarChart, Settings } from "lucide-react"
import WrapUpP2p from "../../p2p/layouts/WrapUpP2p"
import { useDispatch, useSelector } from "react-redux"
import { exchangeSelect, homeScreenStatSelect } from "../../../../redux/selectors"
import { money } from "../../../../utility/Helper1"
import { exchangeActions } from "../../../../redux/actions"

const WalletDashboard = () => {
    const [activeTab, setActiveTab] = useState("withdraw")
    const finance = useSelector(homeScreenStatSelect)
    const dispatch = useDispatch();
    const exchangeData = useSelector(exchangeSelect);
    const allWithdrawals = exchangeData?.filter(el => el.asset == 2)
    const statOnly = allWithdrawals?.map(el => ({ readOnlyTotalWithdrawn: el.activewallet2, status: el.completed }))


    const onLoadPH = () => {
        dispatch(exchangeActions.onGetExchange("p2p/load/all", response => {

        }))
    }

    useEffect(() => {
        onLoadPH()
    }, [])



    return (<WrapUpP2p>
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 py-8">

                {console.log('finance', finance)}
                {/* Wallet Cards */}
                {finance?.map((wallet, index) => (<div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 mb-8">
                    <WalletCard
                        key={wallet.abbrRo}
                        type={'Main Balance'}
                        balance={money(wallet?.balance)}
                        currency={wallet.abbrRo}
                        change={2}
                    />

                    {Number(wallet?.oldwallet) > 0 && <WalletCard
                        key={wallet.abbrRo}
                        type={'Old Wallet'}
                        balance={money(wallet?.oldwallet)}
                        currency={wallet.abbrRo}
                        change={2}
                    />}

                    <WalletCard
                        key={wallet.abbrRo}
                        type={'Commission'}
                        balance={money(wallet?.commission)}
                        currency={wallet.abbrRo}
                        change={2}
                    />
                </div>))}

                {/* Withdrawal Summary */}
                <div className="mb-8">
                    <WithdrawalSummary
                        withdrawals={statOnly}
                    />
                </div>

                {/* Main Wallet Component */}
                <WalletPage />
            </div>
        </div>
    </WrapUpP2p>
    )
}

export default WalletDashboard
